import React from 'react'
import styles from "./styles.module.css";

const IconTransitions = ({ Icon }) => {
  return (
    <div className={styles.transition} >
      <Icon />
    </div>
  )
};

export default IconTransitions;